<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    export let fill: string = $theme.colors.semantic.error[500];
    // width="16" height="17"
</script>

<svg {...$$restProps} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6666 8.8394C14.6666 5.1575 11.6819 2.17273 7.99998 2.17273C4.31808 2.17273 1.33331 5.1575 1.33331 8.8394C1.33331 12.5213 4.31808 15.5061 7.99998 15.5061C11.6819 15.5061 14.6666 12.5213 14.6666 8.8394ZM7.99998 5.00606C8.27612 5.00606 8.49998 5.22992 8.49998 5.50606V9.50606C8.49998 9.78221 8.27612 10.0061 7.99998 10.0061C7.72384 10.0061 7.49998 9.78221 7.49998 9.50606V5.50606C7.49998 5.22992 7.72384 5.00606 7.99998 5.00606ZM7.99998 12.1727C8.36817 12.1727 8.66665 11.8743 8.66665 11.5061C8.66665 11.1379 8.36817 10.8394 7.99998 10.8394C7.63179 10.8394 7.33331 11.1379 7.33331 11.5061C7.33331 11.8743 7.63179 12.1727 7.99998 12.1727Z"
        {fill}
    />
</svg>
